import React from 'react';

import translations from 'services/translations/translations';

// The selling price of a calculation row is always shown as a sum: only the currency
export const getSumUnitOptions = (
  key: string,
  currency = '€'
): JSX.Element[] => [
  <option key={`subproduct-${key}-selling-price-unit-empty`} value="">
    {currency}
  </option>,
];

const getSellingPriceUnitOptions = (
  quantityUnit: string,
  key: string,
  t: any,
  currency = '€'
): JSX.Element[] => {
  const [euroOption] = getSumUnitOptions(key, currency);

  if (quantityUnit === '') {
    return [euroOption];
  }

  const quantityUnitOption = (
    <option
      key={`subproduct-${key}-selling-price-unit-${quantityUnit}`}
      value={quantityUnit}
    >
      {currency}/{t(`${translations.common}:units:${quantityUnit}`)}
    </option>
  );

  return [euroOption, quantityUnitOption];
};

export default getSellingPriceUnitOptions;
